// filepath: /Users/a1111/WebstormProjects/arch-editor/src/components/boards/BoardUml.js
import React from 'react';
import Canvas from '../Canvas';

// UML доска: текущая полноценная логика с кодогенерацией
const BoardUml = ({ diagramId = null, projectId = null }) => {
  return <Canvas initialDiagramId={diagramId} mode="uml" projectId={projectId} />;
};

export default BoardUml;

